import { type PropsWithChildren, type ReactElement } from 'react'

export const HeroImage = ({ children }: PropsWithChildren): ReactElement => {
  return (
    <div className='grid flex-1 place-items-center'>
      <div className='flex flex-col items-center gap-4'>{children}</div>
    </div>
  )
}
